import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { formatPrice, formatPriceWithoutCurrency } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import ReportTabs from './report_tabs';

const KpiCard = ({ label, value, icon, color = '#00C6FE', sub }) => (
    <div className="bg-gray-2 p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 140, borderLeft: `3px solid ${color}` }}>
        <div className="d-flex align-items-center justify-content-between mb-1">
            <span className="gray font-10 poppins">{label}</span>
            {icon && <i className={`${icon} font-12`} style={{ color }} />}
        </div>
        <span className="white poppins toBold" style={{ fontSize: '1.6rem', lineHeight: 1 }}>{value}</span>
        {sub && <span className="font-10 mt-1 poppins" style={{ color }}>{sub}</span>}
    </div>
);

class Close extends React.Component {
    state = {
        menu_toggled: false,
        all_staff: false,
        start: moment(),
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        pickPayment: false,
        filterPaymentId: null,
        pickDate: false,
    }

    componentWillMount() {
        const { id } = this.props.params;
        if (id) {
            let me = fakeAuth.getUser();
            this.props.staffs_actions && this.props.staffs_actions.fetch(me.IdAccount);
        }
    }

    componentWillReceiveProps = nextProps => {
        const { staffs } = nextProps;
        // Solo mostrar usuarios activos (switch "Estado" encendido).
        // Los usuarios a nivel de cuenta (sin ficha de empleado) no tienen switch, por eso se muestran siempre.
        const active_staffs = (staffs || []).filter(s => !s.IdStaff || s.IsActive);
        this.setState({ staffs: active_staffs });
        if (nextProps.report_entries && this.state.microTransac) {
            this.setState({ microTransac: false });
        }
    }

    onToggle = (IdUser) => {
        const { staffs } = this.state;
        let index = _.findIndex(staffs, r => r.IdUser === IdUser);
        if (index === -1) return;
        staffs[index].ON = !staffs[index].ON;
        this.setState({ staffs });
    }

    onToggleAll = () => {
        this.setState({ all_staff: !this.state.all_staff }, () => {
            const { staffs } = this.state;
            staffs.forEach(s => s.ON = this.state.all_staff);
            this.setState({ staffs });
        });
    }

    onGenerate = () => {
        this.setState({ microTransac: true }, () => {
            this.props.logic_actions && this.props.logic_actions.fecth_close_report({
                IdProperty: this.props.params.id,
                Day: this.state.start.format('YYYY-MM-DD'),
            });
        });
    }

    getFilteredReport = () => {
        const { report_entries } = this.props;
        const { staffs = [], filterPaymentId } = this.state;
        const staff_selected = _.chain(staffs).filter(s => s.ON).map(u => u.IdUser).value();
        return _.chain(report_entries || [])
            .filter(u => parseInt(u.Credit))
            .filter(u => staff_selected.indexOf(u.IdUser) !== -1)
            .filter(u => filterPaymentId ? u.IdPaymentType === filterPaymentId : true)
            .groupBy(u => u.IdUser)
            .values()
            .value();
    }

    getTotals = (entries) => {
        return _.chain(entries)
            .groupBy('IdPaymentType')
            .mapValues((group, key) => ({
                name: (_.find(config.payment_types, pt => pt.id === parseInt(key, 10)) || config.payment_types[0]).name,
                total: _.sum(group.map(e => parseFloat(e.Credit) || 0)),
                count: group.length,
            }))
            .values()
            .sortBy(g => -g.total)
            .value();
    }

    renderKpis = () => {
        const filtered_report = this.getFilteredReport();
        const allEntries = _.flatten(filtered_report);
        if (!allEntries.length) return null;

        const total = _.sum(allEntries.map(e => parseFloat(e.Credit) || 0));
        const byPayment = this.getTotals(allEntries);
        const topPayment = byPayment[0];

        return (
            <div className="d-flex flex-wrap mb-3" style={{ gap: 10 }}>
                <KpiCard label="Total recaudado" value={`USD ${total.toFixed(2)}`} icon="fas fa-dollar-sign" color="#00c97a" />
                <KpiCard label="Transacciones" value={allEntries.length} icon="fas fa-receipt" color="#00C6FE" />
                <KpiCard label="Empleados" value={filtered_report.length} icon="fas fa-user-tie" color="#6E44FF" />
                {topPayment && <KpiCard label="Principal forma de pago" value={topPayment.name} icon="fas fa-credit-card" color="#FFC107" sub={`USD ${topPayment.total.toFixed(2)}`} />}
            </div>
        );
    }

    renderSheet = (group, i) => {
        const { staffs } = this.props;
        const { payment_types } = config;
        const user = _.find(staffs, u => u.IdUser === _.first(group).IdUser);
        if (!user) return null;

        const entries = group.map(t => ({
            ...t,
            PaymentType: parseFloat(t.Credit) ? (_.find(payment_types, pt => pt.id === t.IdPaymentType) || _.first(payment_types)).name : '-',
        }));

        const totals = this.getTotals(entries);
        const grandTotal = _.sum(entries.map(e => parseFloat(e.Credit) || 0));

        return (
            <section key={i} className="sheet mt-3 p-4 font-10" style={{ borderRadius: 6, width: 'fit-content', minWidth: '8.5in', margin: 'auto' }}>
                <div className="d-flex align-items-start justify-content-between mb-1">
                    <h2 className="mb-0">{this.state.hotel_name}</h2>
                    <span className="gray font-10 poppins">{moment(_.first(group).CreateDate).format('DD/MM/YYYY')}</span>
                </div>

                <div className="d-flex mt-1 mb-1" style={{ gap: 24 }}>
                    <span className="toBold">Empleado: <i className="toBold">{user.FirstName} {user.LastName}</i></span>
                    <span>Cargo: {user.JobTitle || 'Admin'}</span>
                    {user.Shift && <span>Turno: {user.Shift}</span>}
                </div>

                <h4 className="text-center mb-3">Reporte de cierre de actividad</h4>

                <table className="table table-sm font-8">
                    <thead>
                        <tr>
                            <th>Recibo</th>
                            <th>Id</th>
                            <th>Cliente</th>
                            <th>Concepto</th>
                            <th>Forma de pago</th>
                            <th>Divisa</th>
                            <th className="text-right">Monto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((t, idx) => (
                            <tr key={idx}>
                                <td>{t.Confirmation}</td>
                                <td>{t.IdBookAccounting.slice(-8)}</td>
                                <td>{t.GivenName}</td>
                                <td>{t.Reason}</td>
                                <td>{t.PaymentType}</td>
                                <td>USD</td>
                                <td className="text-right">{formatPriceWithoutCurrency((parseFloat(t.Credit)) * 100)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        {totals.map((t, idx) => (
                            <tr key={idx} className="gray font-8">
                                <td colSpan={5} className="text-right">{t.name} ({t.count} transacciones)</td>
                                <td>USD</td>
                                <td className="text-right toBold">{t.total.toFixed(2)}</td>
                            </tr>
                        ))}
                        <tr style={{ borderTop: '2px solid #555' }}>
                            <td colSpan={5} className="text-right poppins toBold">TOTAL</td>
                            <td className="toBold">USD</td>
                            <td className="text-right poppins toBold">{grandTotal.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>

                <div className="d-flex mt-2">
                    <a href={`/print/close/${this.props.params.id}/${user.IdUser}/${moment(_.first(group).CreateDate).format('YYYY-MM-DD')}`}
                        target="_blank" className="ms-auto btn btn-link btn-sm font-8">
                        <i className="fas fa-print me-2" />Imprimir
                    </a>
                </div>
            </section>
        );
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    renderCommon = () => {
        const { staffs = [] } = this.state;
        const filtered_report = this.getFilteredReport();
        const selectedPayment = _.find(config.payment_types, pt => pt.id === this.state.filterPaymentId);

        return (
            <div>
                {this.renderHeader()}
                <ReportTabs active="close" id={this.props.params.id} />

                <div style={{ position: 'absolute', top: '11em', bottom: 0, left: 100, right: 0 }} className="bg-gray-dark">
                    {/* Left sidebar */}
                    <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: 260, zIndex: 200 }} className="bg-black d-flex flex-column">

                        {/* Date picker */}
                        <div className="p-3" style={{ borderBottom: '1px solid #222' }}>
                            <label className="white poppins font-11 d-block mb-1">Fecha</label>
                            <DatePicker
                                selected={this.state.start}
                                customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Seleccionar fecha" />}
                                showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                                maxDate={moment()}
                                onChange={date => this.setState({ start: moment(date) })}
                            />
                        </div>

                        {/* Payment type filter */}
                        <div className="p-3" style={{ borderBottom: '1px solid #222' }}>
                            <label className="white poppins font-11 d-block mb-1">Forma de pago</label>
                            <div className="black-input d-flex">
                                <Dropdown isOpen={this.state.pickPayment} toggle={() => this.setState({ pickPayment: !this.state.pickPayment })} className="w-100">
                                    <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-2 white bg-transparent d-flex">
                                        <span className="align-self-center font-11">{selectedPayment ? selectedPayment.name : 'Todas'}</span>
                                        <i className="fas fa-chevron-down font-10 white align-self-center ms-auto" />
                                    </DropdownToggle>
                                    <DropdownMenu className="w-100" style={{ maxHeight: 240, overflowY: 'auto' }}>
                                        <DropdownItem onClick={() => this.setState({ filterPaymentId: null, pickPayment: false })}>Todas</DropdownItem>
                                        {config.payment_types.map((pt, i) => (
                                            <DropdownItem key={i} onClick={() => this.setState({ filterPaymentId: pt.id, pickPayment: false })}>{pt.name}</DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>

                        {/* Staff list */}
                        <div className="d-flex flex-column" style={{ flex: 1, overflowY: 'auto' }}>
                            <button onClick={this.onToggleAll} className="btn btn-link btn-lg text-left d-flex justify-content-start px-3">
                                <div className="d-flex flex-column align-self-center">
                                    <span className="white align-self-start line1 font-12">TODO EL STAFF</span>
                                </div>
                                <i className={`fas fa-check ms-auto align-self-center ${this.state.all_staff ? 'green' : 'gray'}`} />
                            </button>
                            <hr className="m-0 p-0" />
                            {staffs && _.sortBy(staffs, 'FirstName').map((staff, i) => (
                                <button key={i} onClick={() => this.onToggle(staff.IdUser)} className="btn btn-link text-left d-flex justify-content-start px-3 py-2">
                                    <div className="d-flex flex-column align-self-center">
                                        <span className="white align-self-start line1 font-12 toUpper">{staff.FirstName} {staff.LastName}</span>
                                        <span className="gray font-10 line1">{staff.JobTitle || 'Admin'}{staff.Shift ? ` | ${staff.Shift}` : ''}</span>
                                    </div>
                                    <i className={`fas fa-check ms-auto align-self-center ${staff.ON ? 'green' : 'gray'}`} />
                                </button>
                            ))}
                        </div>

                        {/* Generate button */}
                        <div className="p-3" style={{ borderTop: '1px solid #222' }}>
                            <button
                                onClick={this.onGenerate}
                                className={`btn w-100 ${_.find(staffs, s => s.ON) ? 'btn-success' : 'btn-link white'} poppins font-12`}
                            >
                                <i className="fas fa-play me-2" />Generar Reporte
                            </button>
                        </div>
                    </div>

                    {/* Right content — sheets stay white/paper, but outer area is full-width dark */}
                    <div style={{ position: 'absolute', top: 0, left: 260, bottom: 0, right: 0, overflowY: 'auto', padding: '16px' }}>
                        {filtered_report.length > 0 && this.renderKpis()}

                        {filtered_report.map((group, i) => this.renderSheet(group, i))}

                        {filtered_report.length === 0 && (
                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                <i className="fas fa-cash-register font-40 gray mb-3" />
                                <h4 className="gray text-center poppins">No se encontraron movimientos de caja</h4>
                                <span className="gray font-12 poppins text-center">Selecciona una fecha, elige empleados y haz clic en Generar.</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default Close;
